import { paths } from "@/router/paths";

export const excludePaths: string[] = [
  paths.auth.login,
  paths.auth.register,
  //   paths.auth.forgot,
];
